<script setup>
//质量仪表板-清单列表
import qualitySearchTable from '../components/common/qualitySearchTable.vue';
import headerCom from '../components/common/header.vue';
import { getLangValue } from "@/utils/common"; //获取后端语言
</script>
<template>
    <!-- 质量dashboard -->
    <div class="quality-qualitySearch1 my-scroll-bar">
        <headerCom :title="getLangValue('dashboard.quality.title')" />
        <div class="main">
            <div class="center mx-2">
                <div class="card px-3 py-2" style="height: calc(100% - 1.3rem ) ;border-radius: 0.55rem;">
                    <div class="my-card-header">{{ getLangValue('dashboard.quality.titleText2') }}</div>
                    <hr class="my-2" style="background-color:  #E9EBEC; opacity: 1;border-top: 1px solid #E9EBEC;" />
                    <div class="my-card-content">
                        <qualitySearchTable :category_id="3" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
.quality-qualitySearch {
    background-color: #2E404C;
    height: 100vh; //way-1
    // height: 100%; //way-2
    // overflow-y: auto; //way-2

    .header {
        height: 60px;

        .title {
            font-size: 24px;
            font-weight: 700;
            color: white;
        }

        .home {
            font-size: 20px;
            font-weight: 700;
            color: white;
        }
    }

    .main {
        height: calc(100vh - 60px); //way-1
        // .left-aside {
        //     display: flex;
        //     // flex-direction: column;
        //     // justify-content: space-between;
        //     width: 500px;
        //     // overflow-y: auto;
        //     margin-bottom: 1.3rem;
        //     height: 100%;
        // }

        .center {
            flex: 1; //way-1
            height: 100%; //way-1
            margin-bottom: 1.3rem; //way-1

            // height: auto;  //way-2
            // margin-bottom: 1.5rem; //way-2
            .card {
                background-color: #495057;
                border: 1px solid #D9D9D980;

                .my-card-header {
                    color: white;
                    font-size: 16px;
                    font-weight: 700;
                }

                .my-card-content {
                    height: calc(100% - 24px - 1rem);

                    .hscode {
                        color: #9599AD;
                        word-break: break-all;

                        .active {
                            color: white !important;
                        }
                    }

                    .search {
                        height: 38px;

                        :deep(.el-input--suffix) {
                            width: 110px;
                            height: 100%;
                        }

                        :deep(.el-input__wrapper) {
                            background-color: #4a5056;
                        }

                        :deep(.el-input__inner) {
                            color: white;
                        }

                        .form-control {
                            background-color: #4a5056;
                            color: white;
                        }
                    }
                }
            }
        }

        // .right-aside {
        //     width: 480px;

        //     .card {
        //         background-color: #495057;
        //         border: 1px solid #D9D9D980;

        //     }
        // }
    }
}
.quality-qualitySearch1 {
    // background-color: #2E404C;
    height: 100vh; //way-1
    // height: 100%; //way-2
    // overflow-y: auto; //way-2

    // .header {
    //     height: 60px;

    //     .title {
    //         font-size: 24px;
    //         font-weight: 700;
    //         color: white;
    //     }

    //     .home {
    //         font-size: 20px;
    //         font-weight: 700;
    //         color: white;
    //     }
    // }

    .main {
        height: calc(100vh - 60px); //way-1
        // .left-aside {
        //     display: flex;
        //     // flex-direction: column;
        //     // justify-content: space-between;
        //     width: 500px;
        //     // overflow-y: auto;
        //     margin-bottom: 1.3rem;
        //     height: 100%;
        // }

        .center {
            flex: 1; //way-1
            height: 100%; //way-1
            margin-bottom: 1.3rem; //way-1

            // height: auto;  //way-2
            // margin-bottom: 1.5rem; //way-2
            .card {
                // background-color: #495057;
                border: 1px solid #D9D9D980;

                .my-card-header {
                    color: #212529;
                    font-size: 16px;
                    font-weight: 700;
                }

                .my-card-content {
                    height: calc(100% - 24px - 1rem);

                    .hscode {
                        color: #9599AD;
                        word-break: break-all;

                        .active {
                            color: #212529 !important;
                        }
                    }

                    .search {
                        height: 38px;

                        :deep(.el-input--suffix) {
                            width: 110px;
                            height: 100%;
                        }

                        :deep(.el-input__wrapper) {
                            // background-color: #4a5056;
                        }

                        :deep(.el-input__inner) {
                            color: #212529;
                        }

                        .form-control {
                            // background-color: #4a5056;
                            color: #212529;
                        }
                    }
                }
            }
        }

        // .right-aside {
        //     width: 480px;

        //     .card {
        //         background-color: #495057;
        //         border: 1px solid #D9D9D980;

        //     }
        // }
    }
}
</style>
